var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidDocumentGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 67,
    viewBox: "0 0 105 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.656 47L103.656 55.6555C103.656 61.1783 99.1791 65.6555 93.6562 65.6555L85.0008 65.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L93.6555 1C99.1783 1 103.655 5.47715 103.655 11V19.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.6555L1 11C0.999999 5.47715 5.47715 0.999994 11 0.999994L19.6555 0.999993",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 65.6555L11.0008 65.6555C5.47794 65.6555 1.00079 61.1783 1.00079 55.6555L1.00079 47",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bf_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5606 23.9653C14.0743 16.6018 20.5844 11.1273 27.9269 11.8842L61.1523 15.3095C62.3779 15.4359 63.6153 15.3881 64.8275 15.1677L75.1051 13.2991C83.1212 11.8416 90.5 17.9998 90.5 26.1472V38.9427C90.5 45.5411 85.5778 51.1027 79.0284 51.9047L66 53.5H25.5016C17.9316 53.5 11.9476 47.084 12.4745 39.5323L13.5606 23.9653Z",
    fill: "url(#paint0_linear_212_3127)",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_212_3127)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.16797,
    y: 6.0144,
    width: 91,
    height: 55,
    rx: 8,
    fill: "url(#paint1_linear_212_3127)",
    fillOpacity: 0.15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3789 23.5222C50.3789 22.6938 51.0505 22.0222 51.8789 22.0222H82.2194C83.0478 22.0222 83.7194 22.6938 83.7194 23.5222C83.7194 24.3506 83.0478 25.0222 82.2194 25.0222H51.8789C51.0505 25.0222 50.3789 24.3506 50.3789 23.5222Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8789 32.0522C50.8789 31.4999 51.3266 31.0522 51.8789 31.0522H82.2194C82.7717 31.0522 83.2194 31.4999 83.2194 32.0522C83.2194 32.6045 82.7717 33.0522 82.2194 33.0522H51.8789C51.3266 33.0522 50.8789 32.6045 50.8789 32.0522Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8789 40.1083C50.8789 39.556 51.3266 39.1083 51.8789 39.1083H71.1427C71.695 39.1083 72.1427 39.556 72.1427 40.1083C72.1427 40.6606 71.695 41.1083 71.1427 41.1083H51.8789C51.3266 41.1083 50.8789 40.6606 50.8789 40.1083Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1932 31.1099C30.3345 31.0972 30.4886 31.0972 30.617 31.1099C33.6736 31.0088 36.1008 28.5446 36.1136 25.5117C36.1136 22.4156 33.558 19.9008 30.4116 19.9008C27.2523 19.9008 24.7095 22.4156 24.7095 25.5117C24.7095 28.5446 27.1367 31.0088 30.1932 31.1099ZM24.1957 43.1908C21.0878 41.1563 21.0878 37.8201 24.1957 35.7729C27.7402 33.4603 33.5322 33.4603 37.051 35.7729C40.1589 37.8075 40.1589 41.1436 37.051 43.1908C33.5193 45.516 27.7274 45.516 24.1957 43.1908Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_212_3127",
    x: 3.11441,
    y: 2.48651,
    width: 96.7133,
    height: 60.3412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.66387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3127",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86555,
    result: "effect2_foregroundBlur_212_3127"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_212_3127",
    x: -11.4875,
    y: -12.6411,
    width: 128.311,
    height: 92.3109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.32773
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_212_3127",
    x: 49.3789,
    y: 22.0222,
    width: 35.3406,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_212_3127",
    x: 49.8789,
    y: 31.0522,
    width: 34.3406,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_212_3127",
    x: 49.8789,
    y: 39.1083,
    width: 23.2637,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_212_3127",
    x: 20.8647,
    y: 19.9008,
    width: 19.5171,
    height: 27.0339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_3127",
    x1: 51.9654,
    y1: 13.0966,
    x2: 51.9654,
    y2: 51.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_212_3127",
    x1: 52.668,
    y1: 6.0144,
    x2: 52.668,
    y2: 61.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidDocumentGood);
export default __webpack_public_path__ + "static/media/bfid-document-good.a8a272b164a8c2c2c70392a357d5dc4c.svg";
export { ForwardRef as ReactComponent };